import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

// Custom icons for TikTok and WhatsApp since they aren't in Lucide by default
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-[#FAF7F3] border-t border-[#EAE2DA] text-[#4F3535]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src="/assets/logo.png"
              alt="Jojo's Boutique Logo"
              className="h-12 object-contain"
            />
          </div>

          {/* Legal & Navigation Links */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            {/* <Link to="/contact" className="text-sm uppercase tracking-widest hover:text-[#6A4B4B] transition-colors">
              Contact
            </Link>
            <Link to="/privacy" className="text-sm uppercase tracking-widest hover:text-[#6A4B4B] transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-sm uppercase tracking-widest hover:text-[#6A4B4B] transition-colors">
              Terms
            </Link> */}
            <p className="text-[#8A7B7B] text-sm">
              &copy; {new Date().getFullYear()} Jojo's Boutique.
            </p>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-6">
            <a
              href="https://www.instagram.com/thejojosboutique?igsh=N2xpeHVnZWV3NXN2&utm_source=qr"
              className="text-[#4F3535] hover:text-[#6A4B4B] transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://www.tiktok.com/@jojosboutick?_r=1&_t=ZS-987TGINiyaF"
              className="text-[#4F3535] hover:text-[#6A4B4B] transition-colors"
              aria-label="TikTok"
            >
              <TikTokIcon className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/254111620459"
              className="text-[#4F3535] hover:text-[#6A4B4B] transition-colors"
              aria-label="WhatsApp"
            >
              <WhatsAppIcon className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
